import {
    Component,
    HostListener,
    ViewChild,
    ElementRef,
    OnInit,
    OnDestroy,
    Input
} from '@angular/core';

import { BehaviorSubject, Observable, Subject, Subscription, merge, fromEvent, timer } from 'rxjs';
import { debounce, tap, takeUntil } from 'rxjs/operators';

const PADDING_LEFT = 150;
const PADDING_RIGHT = 150;

@Component({
    selector: 'app-horizontal-scroll',
    templateUrl: './horizontal-scroll.component.pug',
    styleUrls: ['./horizontal-scroll.component.less']
})
export class HorizontalScrollComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @ViewChild('content', {static: true}) content: ElementRef;

    _leftOpacitySbj = new BehaviorSubject(0);
    leftOpacity$ = this._leftOpacitySbj.asObservable();

    _rightOpacitySbj = new BehaviorSubject(0);
    rightOpacity$ = this._rightOpacitySbj.asObservable();

    _controlsSbj: BehaviorSubject<boolean> = new BehaviorSubject(true);
    public controls$: Observable<boolean> = this._controlsSbj.asObservable();
    @Input() set controls(controls: boolean) {
        this._controlsSbj.next(controls);
    }

    @HostListener('mousewheel', ['$event'])
    onMousewheel(event) {
        if (!this._controlsSbj.getValue()) {
            return;
        }

        event.preventDefault();

        this.content.nativeElement.scrollLeft += event.deltaY / 8;

        this._setLeftOpacity();
        this._setRightOpacity();
    }

    constructor(
    ) {
    }

    ngOnInit() {
        merge(
            fromEvent(this.content.nativeElement, 'DOMNodeRemoved'),
            fromEvent(this.content.nativeElement, 'DOMNodeInserted'),
            this.controls$
        )
            .pipe(takeUntil(this._destroySbj))
            .pipe(debounce(() => timer(0)))
            .pipe(tap(() => this._setLeftOpacity()))
            .pipe(tap(() => this._setRightOpacity()))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    onLeft() {
        const up$ = fromEvent(document.body, 'mouseup');
        let times = 0;

        timer(0, 10)
            .pipe(takeUntil(up$))
            .pipe(tap(() => {
                times++;
                const l = Math.log2(times);
                this.content.nativeElement.scrollLeft -= 1 * l;
            }))
            .pipe(tap(() => this._setLeftOpacity()))
            .pipe(tap(() => this._setRightOpacity()))
            .subscribe();
    }

    onRight() {
        const up$ = fromEvent(document.body, 'mouseup');
        let times = 0;

        timer(0, 10)
            .pipe(takeUntil(up$))
            .pipe(tap(() => {
                times++;
                const l = Math.log2(times);
                this.content.nativeElement.scrollLeft += 1 * l;
            }))
            .pipe(tap(() => this._setLeftOpacity()))
            .pipe(tap(() => this._setRightOpacity()))
            .subscribe();
    }

    _setLeftOpacity() {
        const {
            offsetWidth,
            scrollWidth,
            scrollLeft
        } = this.content.nativeElement;

        const scrollRight = scrollWidth - offsetWidth - scrollLeft;
        let opacity = 1;
        if (scrollRight < PADDING_RIGHT) {
            opacity = scrollRight / 150;
        }

        this._rightOpacitySbj.next(opacity);
    }

    _setRightOpacity() {
        const { scrollLeft } = this.content.nativeElement;

        let opacity = 1;
        if (scrollLeft < PADDING_LEFT) {
            opacity = scrollLeft / 150;
        }

        this._leftOpacitySbj.next(opacity);
    }
}
